const connectionTooltip = {
  0: "Reconnecting",
  1: "Very Bad Connection",
  2: "Bad Connection",
  3: "Moderate Connection",
  4: "Good Connection",
  5: "Excellent Connection",
};
connectionTooltip[-1] = "Network Unknown";

/**
 * @param connectionScore -> 1-5 connection score for network quality
 * @param t - translation function, ex: t('good_connection')
 */
export const getTooltipText = (connectionScore, t) => {
  switch (connectionScore) {
    case -1:
      return t("network_unknown");
    case 0:
      return t("reconnecting");
    case 1:
      return t("very_bad_connection");
    case 2:
      return t("bad_connection");
    case 3:
      return t("moderate_connection");
    case 4:
      return t("good_connection");
    case 5:
      return t("excellent_connection");
    default:
      return "";
  }
};

/**
 * position is needed here as we don't want all the dots/arcs to be colored,
 * the non colored ones will be passed in the default color. If user is
 * disconnected(score=0), no dot/arc will be colored.
 * @param position -> 1 to 5
 * @param connectionScore -> 0 to 5, 0 means disconnected
 * @param defaultColor -> color for components not taking the connection color
 */
export const getColor = (position, connectionScore, defaultColor) => {
  const shouldBeColored = position <= connectionScore;
  if (!shouldBeColored) {
    return defaultColor;
  }
  if (connectionScore >= 4) {
    return "#37F28D";
  } else if (connectionScore >= 3) {
    return "#FAC919";
  } else if (connectionScore >= 1) {
    return "#ED4C5A";
  }
  return defaultColor;
};
